export const campaignIdStringFormat = (item) => {
  return String(item).padStart(8, '0')
}